import React from 'react';
import CrudPage from '../../../components/CrudPage';
import useLookups from '../../../hooks/useLookups';
import { AUDIT_COLUMNS, accountCodeLabel } from '../../../config/columns';
import { currencyService, accountCodeService } from '../../../services/resources';

export default function CurrencyPage({ onToast }) {
  const lookups = useLookups({
    accountCodes: { service: accountCodeService, labelKey: accountCodeLabel },
  });

  const codeLabel = (id) => lookups.accountCodes?.find((o) => o.value === id)?.label ?? id;

  return (
    <CrudPage
      title="Currency"
      formCode="CURRENCY"
      service={currencyService}
      onToast={onToast}
      lookups={lookups}
      searchKeys={['currency_code', 'currency_name']}
      columns={[
        { key: 'currency_code', label: 'Code' },
        { key: 'currency_name', label: 'Name' },
        { key: 'account_code_id', label: 'Account Code', render: (r) => codeLabel(r.account_code_id) },
        { key: 'min_rate', label: 'Min Rate' },
        { key: 'max_rate', label: 'Max Rate' },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        // currency_code locks on edit and is uppercase.
        { key: 'currency_code', label: 'Currency Code', type: 'text', required: true, immutableOnEdit: true, uppercase: true },
        { key: 'currency_name', label: 'Currency Name', type: 'text', required: true },
        { key: 'account_code_id', label: 'Account Code', type: 'select', required: true, lookup: 'accountCodes' },
        { key: 'min_rate', label: 'Min Rate (* batas rate wajar)', type: 'decimal' },
        { key: 'max_rate', label: 'Max Rate (* batas rate wajar)', type: 'decimal' },
        { key: 'description', label: 'Description', type: 'textarea' },
      ]}
    />
  );
}
